import ContactUsContent from 'components/account/contactUs/ContactUsContent';
import React from 'react';
import { Dimensions } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import {
  ColumnWithMargins,
  ScreenContainer,
  SheetDetailsWrapper,
  StyledWrapper,
} from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';

const { height } = Dimensions.get('window');

const ContactWrapper = () => {
  return (
    <StyledWrapper mb={20} center={isWeb} maxWidth={isWeb ? 600 : undefined}>
      <ContactUsContent />
    </StyledWrapper>
  );
};

const ContactSheet = () => {
  if (isWeb) {
    return (
      <ScrollView>
        <ColumnWithMargins mt={30}>
          <ContactWrapper />
        </ColumnWithMargins>
      </ScrollView>
    );
  }

  return (
    <SheetDetailsWrapper pt={25} resetPadding>
      <ScrollView>
        <ContactWrapper />
      </ScrollView>
    </SheetDetailsWrapper>
  );
};

const ContactUs: React.FC = () => {
  return (
    <ScreenContainer mt={isWeb ? 190 : 0}>
      <ContactSheet />
    </ScreenContainer>
  );
};

export default ContactUs;
